import { StyleSheet } from 'react-native';
import { fontFamily } from '../../../constants/palette';

export default StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    maxWidth: 400,
  },
  text: {
    fontFamily,
  },
});
